import { Box } from "@mui/material";
import { formatCurrency, NULL_DISPLAY } from "@platform/design-system";

import type { FinancialsRow } from "../types";
import type { ICellRendererParams } from "ag-grid-community";

export const CurrencyCellRenderer = (
  params: ICellRendererParams<FinancialsRow, number | null>,
): React.JSX.Element => {
  const value = params.value ?? null;

  return (
    <Box component="span" sx={{ whiteSpace: "nowrap" }}>
      {value === null ? NULL_DISPLAY : formatCurrency(value)}
    </Box>
  );
};
